document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("kg-SizeGuidePopup");

  if (!popup) return;

  document.addEventListener("click", function(event){

    if(event.target.closest("[data-size-guide-open]")){
      popup.style.display = "block";
    }

    if(event.target.closest("[data-size-guide-close]")){
      popup.style.display = "none";
    }

  });

});